let dirPath = 'static/games/page004_game0';
let dirAudio = 'games/page004_game0/audio/';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  bruteForce: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    // itemsConfig: { shuffle: true },
    otherProperty: {
      sounds: [{ src: dirAudio + 'click.mp3', id: 'mouseup' }],
    },
    items: [
      {
        itemsConfig: { shuffle: true },
        idGroup: 'right',
        idItem: 'con1',
        items: [{ idGroup: 'left', idItem: 'con1', correct: [{ idGroup: 'right', idItem: 'con1' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'right',
        idItem: 'con2',
        items: [{ idGroup: 'left', idItem: 'con2', correct: [{ idGroup: 'right', idItem: 'con2' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'right',
        idItem: 'con3',
        items: [{ idGroup: 'left', idItem: 'con3', correct: [{ idGroup: 'right', idItem: 'con3' }] }],
      },
    ],
  },
  layout: {
    itemsConfig: {
      background: {},
    },
    otherProperty: {
      // lines: {
      //   good: {
      //     hideLine: true,
      //   },
      //   connect: {
      //     color: '#239ad6',
      //     hideLine: true,
      //   },
      //   select: {
      //     color: '#239ad6',
      //     hideLine: true,
      //   },
      // },
      points: {
        pointMouse: {
          color: 'rgba(255,255,255,0.01)',
          rad: 10,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          color: 'rgba(255,255,255,0.01)',
          positions: { rad: 10 },
        },
      },
      /*    lines: {

            connect: { color: 'black' }
          } */
    },
    groups: [
      {
        idGroup: 'left',
        positions: {
          autoFit: true,
          type: 'absolute',
          fixTab: [
            { x: 276, y: 731 },
            { x: 778, y: 731 },
            { x: 1280, y: 731 },
          ],
        },
        itemsConfig: {
          positions: { pos: { width: 307, height: 307 } },
          background: {
            color: 'rgba(255,255,255,0.01)',
            text: { font: 'Linotype', size: '50px', offset: { y: 6, x: 100 } },
          },
        },
        otherProperty: {
          points: {
            itemsConfig: { positions: { rad: 8 }, registrationPoint: { setTo: 'left' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'top' } } }],
          },
        },
        items: [
          {
            id: 'con1',
            background: { image: { src: dirPath + '/img/bear.png' } },
            otherProperty: {
              audio: 'a01',
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con2',
            background: { image: { src: dirPath + '/img/mole.png' } },
            otherProperty: {
              audio: 'a02',
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con3',
            background: { image: { src: dirPath + '/img/rabbit.png' } },
            otherProperty: {
              audio: 'a03',
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
        ],
      },
      {
        idGroup: 'right',
        positions: {
          autoFit: true,
          type: 'absolute',
          fixTab: [
            { x: 102, y: 144 },
            { x: 782, y: 135 },
            { x: 1464, y: 113 },
          ],
        },
        itemsConfig: {
          positions: { pos: { width: 384, height: 419 } },
          background: { image: { pos: { y: 0 } } },
        },
        otherProperty: {
          // lines: {
          //   good: {
          //     hideLine: true,
          //   },
          //   connect: {
          //     color: '#239ad6',
          //     hideLine: true,
          //   },
          //   select: {
          //     color: '#239ad6',
          //     hideLine: true,
          //   },
          // },
          points: {
            itemsConfig: { positions: { rad: 8 }, registrationPoint: { setTo: 'center' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'bottom' } } }],
          },
        },
        items: [
          {
            id: 'con1',
            positions: { pos: { width: 318, height: 386 } },
            background: { color: 'rgba(255,255,255,0.01)', image: { src: dirPath + '/img/tom.png' } },
            otherProperty: {
              // points: { itemsConfig: { positions: { offset: { x: 100 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con2',
            positions: { pos: { width: 321, height: 395 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/lisa.png' },
            },
            otherProperty: {
              // points: { itemsConfig: { positions: { offset: { x: 110 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con3',
            positions: { pos: { width: 318, height: 386 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/dusty.png' },
            },
            otherProperty: {
              // points: { itemsConfig: { positions: { offset: { x: 100 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
};
let dataConfig = {
  mixinEngine: 'connect',
  fullscreen: true,
  mainImage: {
    imagePath: dirPath + '/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
  },
  mbAudioItemData: [
    {
      maskConfig: {
        click: { src: dirAudio + 'click.mp3' },
        src: 'games/page004_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-331px',
          'margin-top': '-130px',
        },
      },
      id: 'a01',
      src: dirAudio + '6_bear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page004_game0/img/audioOn.png', iconOff: 'games/page004_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 130,
        x: 306,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: dirAudio + 'click.mp3' },
        src: 'games/page004_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-331px',
          'margin-top': '-130px',
        },
      },
      id: 'a02',
      src: dirAudio + '7_mole.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page004_game0/img/audioOn.png', iconOff: 'games/page004_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 130,
        x: 306,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: dirAudio + 'click.mp3' },
        src: 'games/page004_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-331px',
          'margin-top': '-130px',
        },
      },
      id: 'a03',
      src: dirAudio + '5_rabbit.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page004_game0/img/audioOn.png', iconOff: 'games/page004_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 130,
        x: 306,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
  ],
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
